import { BoxArrowUpIcon } from '@phosphor-icons/react'
import { useTranslation } from 'react-i18next'

import { useBulkUnarchivePackages } from '@/api/packages/bulk-unarchive-packages'
import { ConfirmationPopup } from '@/components/ui/confirmation-popup'
import { Typography } from '@/components/ui/typography'
import { toastFactory } from '@/factories'
import { PackageModel } from '@/models'
import { getApiErrorMessage } from '@/utils'

import * as S from './bulk-unarchive-modal.styled'

export interface BulkUnarchiveModalProps {
  onClose: () => void
  packages: PackageModel[]
}

export const BulkUnarchiveModal = ({ onClose, packages }: BulkUnarchiveModalProps) => {
  const { t } = useTranslation(['packages'])
  const { mutateAsync: bulkUnarchive, isPending } = useBulkUnarchivePackages()
  const count = packages.length

  const handleConfirm = async () => {
    try {
      await bulkUnarchive({ ids: packages.map((pkg) => pkg.id) })
      toastFactory.success(t('packages:bulkUnarchiveModal.toastSuccess', { count }))
      onClose()
    } catch (error) {
      toastFactory.error(getApiErrorMessage(error))
    }
  }

  return (
    <ConfirmationPopup
      autoWidth
      variant="info"
      title={t('packages:bulkUnarchiveModal.title', { count })}
      confirmText={t('packages:bulkUnarchiveModal.confirm')}
      cancelText={t('packages:bulkUnarchiveModal.cancel')}
      closeable={!isPending}
      closeOnOverlayClick={!isPending}
      closeOnEscapeKey={!isPending}
      confirmIcon={BoxArrowUpIcon}
      onConfirm={handleConfirm}
      onClose={onClose}
    >
      <S.Container>
        <Typography color="black700" size="heading-medium" weight="medium">
          {t('packages:bulkUnarchiveModal.body')}
        </Typography>
      </S.Container>
    </ConfirmationPopup>
  )
}
